import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog"
import List from "@material-ui/core/List"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Slide from "@material-ui/core/Slide"

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function FormDialog({ open, close }) {
  const classes = useStyles()

  return (
    <div dividers className={classes.dialogContent}>
      <Dialog
        fullScreen
        open={open}
        onClose={() => close()}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar} position="fixed">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => close()}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <List style={{ height: "90%" }}>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSes11UhEaEz4CgHOXlxVh-TeOFKZVio6xndoaMbL62SnFQ7CA/viewform?embedded=true"
            width="100%"
            height="100%"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </List>
      </Dialog>
    </div>
  )
}

// const FormDialog = ({ open, close }) => {
//   const classes = useStyles()
//   return (
//     <Dialog
//       maxWidth="lg"
//       style={{ maxWidth: "80vw", maxHeight: "80vh", margin: "0 auto" }}
//       open={open}
//       onClose={() => close()}
//     >
//       {/* <DialogTitle>
//         <div className={classes.dialogTitle}>
//           <img
//             src={SVBLogo}
//             className={classes.SVicons}
//             alt="SourceView Logo"
//           />
//           <div className={classes.title}>
//             <Typography variant="h5">
//               Want this tool in your language?
//             </Typography>
//           </div>
//           <div className={classes.closeButtonHolder}>
//             <IconButton
//               aria-label="close"
//               className={classes.closeButton}
//               onClick={() => close()}
//             >
//               <CloseIcon />
//             </IconButton>
//           </div>
//         </div>
//       </DialogTitle> */}
//       <div dividers className={classes.dialogContent}>
//         <iframe
//           src="https://docs.google.com/forms/d/e/1FAIpQLSes11UhEaEz4CgHOXlxVh-TeOFKZVio6xndoaMbL62SnFQ7CA/viewform?embedded=true"
//           width="640"
//           height="1200"
//           frameborder="0"
//           marginheight="0"
//           marginwidth="0"
//           scrolling="no"
//           style={{ marginBottom: 50 }}
//         >
//           Loading…
//         </iframe>
//       </div>
//     </Dialog>
//   )
// }

// export default FormDialog
